(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/services/pay-tickets.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/services/pay-tickets.js');
"use strict";

const accountServices = svs.tur.pay.account_services;
const mapProductType = svs.ticketgames.ticketMappings.productMappings.mapProductType;
const trackTicketsTransactionData = _ref => {
  let giftedVouchers = _ref.response.giftedVouchers,
    _ref$request = _ref.request,
    products = _ref$request.products,
    price = _ref$request.price;
  try {
    const slicedId = giftedVouchers[0] && giftedVouchers[0].VoucherId.slice(0, 8);
    const items = [];
    products.forEach(voucher => {
      for (let i = 0; i < voucher.count; i++) {
        items.push(new svs.components.analytics.transactionItem('VOUCHER', voucher.name, svs.utils.format.CurrencyFromJupiterString(voucher.value), 1, {
          gameType: voucher.type
        }));
      }
    });
    const trans = new svs.components.analytics.transaction(slicedId, svs.utils.format.CurrencyFromJupiterString(price), items, 0, 0, undefined, 'VOUCHER');
    svs.components.analytics.trackTransaction(trans);
  } catch (error) {
    svs.tickets_giftshop.logger.warn('Could not track vouchers', error);
  }
};
const trackTicketsMetaData = _ref2 => {
  let trackingData = _ref2.trackingData;
  const cart = trackingData.cart,
    dateSelectorUsed = trackingData.dateSelectorUsed,
    dateSelector = trackingData.dateSelector;
  svs.components.analytics.trackEvent({
    category: 'VOUCHER',
    action: 'voucher_date_selector',
    opt_label: (dateSelectorUsed === null || dateSelectorUsed === void 0 ? void 0 : dateSelectorUsed.toLowerCase()) || (dateSelector === null || dateSelector === void 0 ? void 0 : dateSelector.toLowerCase())
  });
  cart.forEach(_ref3 => {
    var _product$type;
    let product = _ref3.product,
      amount = _ref3.amount;
    const productType = mapProductType((_product$type = product.type) === null || _product$type === void 0 ? void 0 : _product$type.split(':')[0]);
    for (let i = 0; i < amount; i++) {
      svs.components.analytics.trackEvent({
        category: 'VOUCHER',
        action: "theme_".concat(productType, "_").concat(product.skinId),
        opt_label: product.skinDescription
      });
    }
  });
};
const buyTickets = async _ref4 => {
  let request = _ref4.request,
    trackingData = _ref4.trackingData,
    next = _ref4.next;
  svs.ui.loader.show();
  try {
    const _await$svs$tur$apiCal = await svs.tur.apiCaller.ticketgames.postGiftVouchers({
        data: request
      }),
      response = _await$svs$tur$apiCal.response;
    trackTicketsMetaData({
      trackingData
    });
    trackTicketsTransactionData({
      response,
      request
    });
    svs.tickets_giftshop.clearLocalStorage();
    next({
      response
    });
  } catch (error) {
    throw new Error(error);
  } finally {
    svs.ui.loader.hide();
  }
};
const handleBuyTicketsResult = _ref5 => {
  let next = _ref5.next,
    error = _ref5.error;
  if (error) {
    svs.tickets_giftshop.logger.warn('Payment failed with error:', error);
    throw error;
  } else {
    svs.tickets_giftshop.clearLocalStorage();
    next();
  }
};
const getAccountBalanceParams = _ref6 => {
  let product = _ref6.product,
    price = _ref6.price,
    multi = _ref6.multi;
  if (!product) return {
    price
  };
  return {
    price,
    product,
    isAutoPayAfterDeposit: true,
    title: multi ? "Du beh\xF6ver s\xE4tta in pengar f\xF6r att kunna betala och ge bort dina lotter" : "Du beh\xF6ver s\xE4tta in pengar f\xF6r att kunna betala och ge bort din lott",
    message: 'Observera att spelet inte går att annullera.'
  };
};
const isPayAfterDeposit = () => {
  const isPayAfterDeposit = svs.utils.paramHandler.get({
    key: 'afterpay'
  }).value;
  svs.utils.paramHandler.remove({
    key: 'afterpay'
  });
  return Boolean(isPayAfterDeposit);
};
const payTickets = _ref7 => {
  let request = _ref7.request,
    onCancel = _ref7.onCancel,
    onDone = _ref7.onDone,
    trackingData = _ref7.trackingData;
  const brand = ['triss', 'skrapspel'].find(p => p === svs.tickets_giftshop.data.moduleConfig.branding);
  const payAfterDeposit = isPayAfterDeposit();
  const shouldPayAfterDeposit = payAfterDeposit;
  const price = request.price,
    products = request.products,
    deliveryDate = request.deliveryDate,
    recipientName = request.recipientName;
  const multi = products.length > 1 || products.some(product => product.count > 1);
  let accountBalance;
  let product;
  let error;
  const calls = [{
    in: () => ({
      price,
      product
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    in: () => ({
      spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.ALL, accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
    }),
    fn: accountServices.playerSpelpaus
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    fn: accountServices.playerDepositLimits
  }, {
    in: () => getAccountBalanceParams({
      product: brand,
      price,
      multi
    }),
    fn: accountServices.accountBalance,
    out: args => {
      var _args = args;
      accountBalance = _args.accountBalance;
      return _args;
    }
  }, ...(shouldPayAfterDeposit ? [] : [{
    in: () => ({
      price,
      accountBalance,
      payAfterDeposit,
      products
    }),
    fn: svs.tickets_giftshop.dialogs.confirmPayment
  }]), {
    in: () => ({
      request,
      trackingData
    }),
    fn: buyTickets,
    out: args => {
      var _args2 = args;
      error = _args2.error;
      return _args2;
    }
  }, {
    in: () => ({
      error
    }),
    fn: handleBuyTicketsResult
  }, {
    in: () => ({
      deliveryDate,
      products,
      recipientName
    }),
    fn: svs.tickets_giftshop.dialogs.successPayment
  }];
  const cancel = () => {
    onCancel === null || onCancel === void 0 || onCancel();
  };
  const done = () => {
    onDone === null || onDone === void 0 || onDone({
      error
    });
  };
  svs.tur.pay.initPay({
    calls,
    cancel,
    done,
    shouldDisplayGeneralError: false
  });
};
setGlobal('svs.tickets_giftshop.services.payTickets', payTickets);

 })(window);